import { useEffect, useState } from "react";
import apiService from "../../../services/service";
import API_ROUTES from "../../../api-routes";
import { useParams } from "react-router-dom";
import z from "zod";

function useRequestAttachment() {
  const [attachment, setAttachment] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState(10);
  const [isDataAvailable, setIsDataAvailable] = useState(true);
  const [first, setFirst] = useState(0);
  const [attachmentConfirmModal, setAttachmentConfirmModal] = useState(false);
  const [temporaryMessage, setTemporaryMessage] = useState("");
  const [isAttachmentLoader, setIsAttachmentLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [restoreMessage, setRstoreMessage] = useState("");
  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };
  const { id } = useParams();

  const fetchAttachment = async () => {
    setLoading(true);
    setIsDataAvailable(true);
    const { data } = await apiService(API_ROUTES.FETCH_DOCUMENTS, "GET", {
      replace: { id, type: "AD_HOC" },
    });
    if (data?.length) {
      setAttachment(data);
      setIsDataAvailable(true);
    } else {
      setAttachment([]);
      setIsDataAvailable(false);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchAttachment();
  }, []);

  const handleDeleteDocument = (file) => {
    setAttachmentConfirmModal(true);
    setSelectedFile(file);
  };
  const handleConfirmDelete = async () => {
    setIsAttachmentLoader(true);
    setRstoreMessage("");
    setTemporaryMessage("");
    const { status } = await apiService(
      API_ROUTES.DELETE_ATTACHMENT,
      "DELETE",
      {
        body: { blobUrl: selectedFile?.blob_url, name: selectedFile?.name },
        replace: {
          relatedId: id,
          relatedType: "REQUEST",
        },
      },
    );
    if (status) {
      setTimeout(async () => {
        setLoading(true);
        await fetchAttachment();
        setAttachmentConfirmModal(false);
        setTemporaryMessage(`File ${selectedFile?.name} has been deleted.`);
        setIsAttachmentLoader(false);
      }, 2000);
    }
  };

  const handleRestoreAttachment = async () => {
    setTemporaryMessage("");
    setRstoreMessage("");
    const { status } = await apiService(API_ROUTES.RESTORE_ATTACHMENT, "POST", {
      body: { blobUrl: selectedFile?.blob_url, name: selectedFile?.name },
    });
    if (status) {
      setTimeout(async () => {
        await fetchAttachment();
        setRstoreMessage(`${selectedFile?.name} has been restored.`);
      }, 2000);
    }
  };

  return {
    attachment,
    loading,
    rows,
    onPageChange,
    isDataAvailable,
    first,
    handleDeleteDocument,
    attachmentConfirmModal,
    setAttachmentConfirmModal,
    handleConfirmDelete,
    handleRestoreAttachment,
    temporaryMessage,
    isAttachmentLoader,
    successMessage,
    setSuccessMessage,
    restoreMessage,
    setRstoreMessage,
    setTemporaryMessage,
  };
}

export default useRequestAttachment;
